import { Principal } from '@icp-sdk/core/principal'
import { isAddress } from '@solana/kit'
import Decimal from 'decimal.js'
import { config } from '../appConfig'

const ACCOUNT_ID_LENGTH = 64
const ALPHANUM_REGEX = /^[a-zA-Z0-9]+$/
const ETH_REGEX = /^(0x)?[0-9a-fA-F]{40}$/
const BTC_ADDRESS_REGEX = /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^[bB][cC]1[pPqQ][a-zA-Z0-9]{38,58}$/
const DOGE_ADDRESS_REGEX =
  config.fetchEnv('BITCOIN_CHAIN') === 'testnet'
    ? /^n[1-9A-HJ-NP-Za-km-z]{33}$/
    : /^D[5-9A-HJ-NP-U][1-9A-HJ-NP-Za-km-z]{32}$/
const LTC_ADDRESS_REGEX = /^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$|^ltc1[a-z0-9]{39,59}$/i
export const CANISTER_MAX_LENGTH = 27

export function sanitizeDecimalInput(amount: string, callback: (value: string) => void) {
  if (!amount || amount.match(/^\d{1,}((\.|\,)\d{0,20})?$/)) {
    callback(amount.replace(',', '.'))
  }
}

export function decimalsToE8s(amount: string, decimals: number) {
  return Decimal(amount || 0)
    .mul(Decimal(10).pow(decimals))
    .floor()
    .toFixed()
}

export function e8sToDecimals(amount: string | number | bigint, decimals: number) {
  const decimals_as_e8s = 10 ** decimals
  const normalizedAmount = typeof amount === 'number' ? amount : Number(amount)

  return Decimal(normalizedAmount).div(decimals_as_e8s).toNumber()
}

export function numberToString(number: number) {
  return Decimal(number).toFixed()
}

export function validatePrincipal(principal: string) {
  try {
    Principal.fromText(principal)
    return true
  } catch (error) {
    return false
  }
}

export const validateAccountId = (text: string) =>
  text.length === ACCOUNT_ID_LENGTH && ALPHANUM_REGEX.test(text)

export const validateCanisterId = (text: string) => {
  try {
    return text.length <= CANISTER_MAX_LENGTH && validatePrincipal(text)
  } catch (e) {
    return false
  }
}

export const validateEthAddress = (text: string) => ETH_REGEX.test(text)
export const validateBtcAddress = (text: string) => BTC_ADDRESS_REGEX.test(text)
export const validateSolAddress = (text: string) => isAddress(text)
export const validateDogeAddress = (text: string) => DOGE_ADDRESS_REGEX.test(text)
export const validateLtcAddress = (text: string) => LTC_ADDRESS_REGEX.test(text)
